import cookie from 'vue-cookies'

export default {
    token: state => {
        // state.token;
        return state.token
        // return cookie.get('token')
    },
    user: state => {
        return state.user
        // return JSON.parse(localStorage.getItem('user'));
        // return cookie.get('user');
    },
    isExistAccessToken: state => {
        // return !!cookie.get('token');
        return !!localStorage.getItem('token');
    },
    currentUser: state => {
        state.current_user;
    },
    oldPassword: state => {

        return state.oldPassword;
    },
    password: state => {
        return state.password;
    },
    confirmation: state => {
        return state.confirmation;
    },
}

